
export * from './spinner.component';
export * from './spinner.module';